import apiUrl from "../../../../../utils/settings";

export const loginUrl = () => {
  return apiUrl + "/auth/v2/login";
};

export const logoutUrl = () => {
  return apiUrl + "/auth/logout";
};

export const getMeUrl = () => {
  return apiUrl + "/users/me";
};

export const deleteNotificationTokenUrl = (token) => {
  return (
    apiUrl +
    `/user-notifications/delete-registration-token?token_string=${token}`
  );
};
